function isActiveApp(app) {
  if (!app.url)
    return !1;
  const currentHost = window.location.hostname;
  return new URL(app.url).hostname === currentHost;
}
function handleAppSwitcherSelection(app) {
  window.open(app.url, "_blank");
}
export {
  handleAppSwitcherSelection,
  isActiveApp
};
//# sourceMappingURL=utils.js.map
